import { render, staticRenderFns } from "./BrandParts.vue?vue&type=template&id=050ada19&scoped=true&"
import script from "./BrandParts.vue?vue&type=script&lang=js&"
export * from "./BrandParts.vue?vue&type=script&lang=js&"
import style0 from "./BrandParts.vue?vue&type=style&index=0&id=050ada19&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050ada19",
  null
  
)

export default component.exports